import { Flex, Typography, theme } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import Icon from "../../../../Icon/index.tsx"
import { type svg } from "../../../../Icon/img"

const { Text } = Typography

const TOUR_AREAS: Array<{ key: string; icon: keyof typeof svg }> = [
  { key: "dashboard", icon: "Home" },
  { key: "leads", icon: "Leads" },
  { key: "projects", icon: "Projects" },
  { key: "finance", icon: "Dollar" },
  { key: "files", icon: "Upload" },
  { key: "customers", icon: "Customers" },
  { key: "subcontractors", icon: "Subcontractors" },
  { key: "calendar", icon: "Calendar" }
]

/** A teaser for the tour about to start — purely informational, the tour
 * itself begins from the page's own primary action, not from clicking here. */
export const ExploreStepPanel = () => {
  const { t } = useTranslation()
  const { token } = theme.useToken()

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
      {TOUR_AREAS.map((area) => (
        <Flex
          key={area.key}
          vertical
          align="center"
          gap={6}
          className="rounded-lg border border-border p-4"
        >
          <Flex
            align="center"
            justify="center"
            className="size-9 rounded-full"
            style={{ background: token.colorPrimaryBg, color: token.colorPrimary }}
          >
            <Icon type={area.icon} />
          </Flex>
          <Text className="text-sm font-medium text-center">
            {t(`guide.tours.platformTour.steps.${area.key}.title`)}
          </Text>
        </Flex>
      ))}
    </div>
  )
}
